export default "__VITE_ASSET__CJzWyY3k__"